/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetCustomerIdClipsParams,
  TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest,
  TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest,
  TrainWithMeModulesClipsDtosResponsesClipEntryResponse,
  TrainWithMeModulesClipsDtosResponsesGetClipGalleryResponse,
  TrainWithMeModulesClipsDtosResponsesGetClipTimelineResponse,
  TrainWithMeModulesClipsDtosResponsesPostClipSlotResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCustomerIdClips = (
    id: number,
    params?: GetCustomerIdClipsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesGetClipGalleryResponse>(
      {url: `/customer/${id}/clips`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdClipsQueryKey = (id: number,
    params?: GetCustomerIdClipsParams,) => {
    return [
    `/customer/${id}/clips`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdClipsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdClips>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdClipsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdClips>>> = ({ signal }) => getCustomerIdClips(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdClipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdClips>>>
export type GetCustomerIdClipsQueryError = ErrorType<unknown>


export function useGetCustomerIdClips<TData = Awaited<ReturnType<typeof getCustomerIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdClipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdClips>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdClips<TData = Awaited<ReturnType<typeof getCustomerIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdClips>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdClips<TData = Awaited<ReturnType<typeof getCustomerIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdClips<TData = Awaited<ReturnType<typeof getCustomerIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdClipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdClipsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdExerciseExerciseIdClips = (
    id: number,
    exerciseId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesGetClipTimelineResponse>(
      {url: `/customer/${id}/exercise/${exerciseId}/clips`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerIdExerciseExerciseIdClipsQueryKey = (id: number,
    exerciseId: number,) => {
    return [
    `/customer/${id}/exercise/${exerciseId}/clips`
    ] as const;
    }


export const getGetCustomerIdExerciseExerciseIdClipsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError = ErrorType<unknown>>(id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdExerciseExerciseIdClipsQueryKey(id,exerciseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>> = ({ signal }) => getCustomerIdExerciseExerciseIdClips(id,exerciseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && exerciseId !== null && exerciseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdExerciseExerciseIdClipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>>
export type GetCustomerIdExerciseExerciseIdClipsQueryError = ErrorType<unknown>


export function useGetCustomerIdExerciseExerciseIdClips<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseExerciseIdClips<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseExerciseIdClips<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdExerciseExerciseIdClips<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdClips>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdExerciseExerciseIdClipsQueryOptions(id,exerciseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerIdExerciseExerciseIdClipsPromote = (
    id: number,
    exerciseId: number,
    trainWithMeModulesClipsDtosRequestsPostClipPromotionRequest?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesClipEntryResponse>(
      {url: `/customer/${id}/exercise/${exerciseId}/clips/promote`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClipsDtosRequestsPostClipPromotionRequest, signal
    },
      options);
    }




export const getPostCustomerIdExerciseExerciseIdClipsPromoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>}, TContext> => {

const mutationKey = ['postCustomerIdExerciseExerciseIdClipsPromote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>, {id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>}> = (props) => {
          const {id,exerciseId,data} = props ?? {};

          return  postCustomerIdExerciseExerciseIdClipsPromote(id,exerciseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdExerciseExerciseIdClipsPromoteMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>>
    export type PostCustomerIdExerciseExerciseIdClipsPromoteMutationBody = BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest> | undefined
    export type PostCustomerIdExerciseExerciseIdClipsPromoteMutationError = ErrorType<unknown>

    export const usePostCustomerIdExerciseExerciseIdClipsPromote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsPromote>>,
        TError,
        {id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipPromotionRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerIdExerciseExerciseIdClipsPromoteMutationOptions(options), queryClient);
    }
    export const postCustomerIdExerciseExerciseIdClipsSlot = (
    id: number,
    exerciseId: number,
    trainWithMeModulesClipsDtosRequestsPostClipSlotRequest?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClipsDtosResponsesPostClipSlotResponse>(
      {url: `/customer/${id}/exercise/${exerciseId}/clips/slot`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClipsDtosRequestsPostClipSlotRequest, signal
    },
      options);
    }




export const getPostCustomerIdExerciseExerciseIdClipsSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>}, TContext> => {

const mutationKey = ['postCustomerIdExerciseExerciseIdClipsSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>, {id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>}> = (props) => {
          const {id,exerciseId,data} = props ?? {};

          return  postCustomerIdExerciseExerciseIdClipsSlot(id,exerciseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdExerciseExerciseIdClipsSlotMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>>
    export type PostCustomerIdExerciseExerciseIdClipsSlotMutationBody = BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest> | undefined
    export type PostCustomerIdExerciseExerciseIdClipsSlotMutationError = ErrorType<unknown>

    export const usePostCustomerIdExerciseExerciseIdClipsSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>, TError,{id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdExerciseExerciseIdClipsSlot>>,
        TError,
        {id: number;exerciseId: number;data?: BodyType<TrainWithMeModulesClipsDtosRequestsPostClipSlotRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerIdExerciseExerciseIdClipsSlotMutationOptions(options), queryClient);
    }
